import type { CityConfig } from "../city-template/types";

export const cedarCityUTConfig: CityConfig = {
  city: "Cedar City",
  state: "Utah",
  stateAbbr: "UT",
  slug: "cedar-city",
  route: "/cedar-city",
  title: "Emergency Passport Cedar City, UT | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Cedar City, UT — as fast as 24 hours. Serving Iron County and Southern Utah. A+ BBB rated registered State Dept. courier serving SUU and the Shakespeare Festival region. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Cedar City, UT",
  heroSubtitle: "SUU study abroad trip to Oxford in 5 days and your passport expired? Shakespeare Festival company touring to Stratford-upon-Avon and documents not ready? Cedar Breaks National Monument artist residency in Italy departing next week? We help Cedar City residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20view%20of%20Cedar%20City%20Utah%20with%20Southern%20Utah%20University%20campus%20Adams%20Shakespearean%20Theatre%20replica%20red%20rock%20mountain%20backdrop%20Kolob%20Canyons%20Zion%20National%20Park%20distant%20peaks%20high%20desert%20landscape%20autumn%20colors%20professional%20photography%20blue%20sky&width=1800&height=700&seq=cedar-city-ut-hero-2026&orientation=landscape",
  heroImageAlt: "Cedar City Utah with SUU campus and Kolob Canyons mountain backdrop at golden hour",
  geoPosition: "37.6775;-113.0619",
  geoPlacename: "Cedar City, Utah",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Located in Aurora, CO — approximately 600 miles east of Cedar City via I-15/I-70",
  },
  nearbyCitiesZips: [
    { name: "Cedar City", zips: "84720, 84721" },
    { name: "Enoch", zips: "84721" },
    { name: "Parowan", zips: "84761" },
    { name: "Panguitch", zips: "84759" },
    { name: "St. George", zips: "84770, 84790" },
    { name: "Hurricane", zips: "84737" },
    { name: "Washington", zips: "84780" },
    { name: "Kanab", zips: "84741" },
    { name: "Beaver", zips: "84713" },
    { name: "Richfield", zips: "84701" },
    { name: "Milford", zips: "84751" },
    { name: "Fillmore", zips: "84631" },
    { name: "Delta", zips: "84624" },
    { name: "Mesquite", zips: "89027" },
    { name: "St. George", zips: "84770" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Iron County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Southern Utah Gateway", desc: "Serving Cedar City, Enoch, Parowan, and all of Iron County" },
  ],
  internalLinks: [
    { name: "Expedited passport services in St. George, UT", route: "/st-george" },
    { name: "Fast passport renewal in Salt Lake City, UT", route: "/salt-lake-city" },
    { name: "Emergency passport help in Provo, UT", route: "/provo" },
    { name: "Urgent passport services in Las Vegas, NV", route: "/las-vegas" },
    { name: "Same-day passport help in Denver, CO", route: "/denver" },
    { name: "Passport courier services in Ogden, UT", route: "/ogden" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Cedar City remotely via secure courier. We do not have a walk-in office in Cedar City — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Iron County and Southern Utah.",
  fpcOfficeAddress: "299 S Main St, Salt Lake City, Utah 84111",
  fpcOfficeDistance: "Serving all of Iron County and the Southern Utah region including Washington, Kane, and Beaver counties",
  serviceAreaIntro: "From the vibrant SUU campus and the world-renowned Utah Shakespeare Festival to the growing community of Enoch, from the historic pioneer town of Parowan with its rock church to the scenic mountain retreat of Brian Head, from the ranching hub of Beaver to the gateway community of Kanab — Fast Passport Center serves the entire Southern Utah and Colorado Plateau region. We regularly help travelers from Cedar City, St. George, and surrounding communities get their passports fast without the 600-mile drive to Denver.",
  nearbyCitiesIntro: "We serve all Cedar City neighborhoods and the surrounding Southern Utah area including Enoch, Parowan, Panguitch, St. George, Hurricane, Kanab, Beaver, and Richfield. If you are anywhere in Iron County, Washington County, or Kane County, we have you covered.",
  howItWorksIntro: "Most Cedar City travelers complete everything online and ship documents overnight. No need to drive to Denver or Las Vegas — we handle the courier submission for you.",
  mistakesIntro: "Cedar City travelers often face a 9-hour drive to the nearest regional passport agency in Denver. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Cedar City and Iron County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Cedar City? Here are the most common ones we hear from Southern Utah travelers.",
  statePageRoute: "/states/utah",
  statePageName: "Utah",
  dmvWebsite: "https://dmv.utah.gov",
  dmvLabel: "Utah DMV — Division of Motor Vehicles",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Utah Vital Records (Birth, Death, Marriage)", href: "https://vitalrecords.utah.gov/" },
    { label: "Iron County Clerk Vital Records", href: "https://www.ironcounty.net/departments/clerk-auditor" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Cedar City travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Rebecca T.",
      location: "Cedar City, UT",
      rating: 5,
      text: "SUU study abroad in Stratford-upon-Avon in 5 days and my passport had expired. Fast Passport Center got it in 28 hours. Festival City to Shakespeare's hometown — dream came true!",
      service: "Passport Renewal",
    },
    {
      name: "Kevin M.",
      location: "Enoch, UT",
      rating: 5,
      text: "Art residency in Florence, Italy departing in 6 days. Fast Passport Center processed my emergency renewal in 30 hours. Cedar City to the Renaissance — the dedicated agent made it happen.",
      service: "Emergency Passport",
    },
    {
      name: "Anna L.",
      location: "Parowan, UT",
      rating: 5,
      text: "Our daughter needed her first passport for a school trip to Paris. Fast Passport Center handled the child passport perfectly. Got it in 4 days. Incredible service for Iron County families.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "cedar-city-ut-1",
      name: "Cedar City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "333 N Main St",
      city: "Cedar City",
      state: "UT",
      zip: "84721",
      phone: "(435) 586-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Cedar City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Cedar City facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "cedar-city-ut-2",
      name: "Iron County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "68 S 100 E",
      city: "Parowan",
      state: "UT",
      zip: "84761",
      phone: "(435) 477-8340",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "20 miles northeast of Cedar City",
      website: "https://www.ironcounty.net/departments/clerk-auditor",
      websiteLabel: "Iron County Clerk",
      notes: "Accepts passport applications. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "cedar-city-ut-3",
      name: "St. George Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1150 E Riverside Dr",
      city: "St. George",
      state: "UT",
      zip: "84790",
      phone: "(435) 673-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "55 miles southwest of Cedar City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Washington County. Larger facility with more availability.",
      icon: "ri-mail-line",
    },
    {
      id: "cedar-city-ut-4",
      name: "Richfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "93 N Main St",
      city: "Richfield",
      state: "UT",
      zip: "84701",
      phone: "(435) 896-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "70 miles northeast of Cedar City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Sevier County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 9 hour drive to Denver", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Cedar City photo shops sometimes use off-white or artistic backgrounds. Passport photos must be exactly 2×2 inches with a pure white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Iron County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Cedar City applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Denver regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Iron County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Cedar City travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Cedar City." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Cedar City address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Cedar City before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Cedar City for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 9-hour drive to Denver." },
    { q: "How fast can I renew my passport in Cedar City?", a: "Fast Passport Center offers fast passport renewal in Cedar City in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Cedar City?", a: "The nearest regional passport agency to Cedar City is the Denver Passport Agency, approximately 600 miles east via I-15/I-70. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Cedar City without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Cedar City?", a: "Same-day passport appointments are only available at the Denver Regional Passport Agency — approximately 9 hours from Cedar City — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Iron County and Southern Utah residents." },
    { q: "Do you serve the entire Southern Utah region?", a: "Absolutely. Fast Passport Center serves the entire Southern Utah region including Cedar City, Enoch, Parowan, St. George, Hurricane, Kanab, Beaver, and surrounding areas. Our courier service works seamlessly from any address in Iron County, Washington County, or Kane County." },
    { q: "Can I expedite a child passport in Cedar City?", a: "Yes. Fast Passport Center expedites child passports in Cedar City for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Iron County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Cedar City with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Denver Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Cedar City", address: "1330 S Providence Center Dr, Cedar City, UT 84720", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
    { name: "Smith's — Cedar City", address: "633 S Main St, Cedar City, UT 84720", hours: "Mon–Sun: 6AM–11PM", website: "https://www.smithsfoodanddrug.com/stores" },
    { name: "Lin's Marketplace — Cedar City", address: "150 N Main St, Cedar City, UT 84720", hours: "Mon–Sun: 7AM–10PM", website: "https://www.linsgrocery.com/stores" },
    { name: "Walmart Supercenter — St. George", address: "2610 Pioneer Rd, St. George, UT 84790", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
  ],
  dmvLocations: [
    {
      name: "Utah DMV — Cedar City",
      address: "176 N Main St, Cedar City, UT 84720",
      hours: "Mon–Fri: 7AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Utah DMV — St. George",
      address: "1449 W Sunset Blvd, St. George, UT 84770",
      hours: "Mon–Fri: 7AM–5PM",
      note: "Serves Washington County. Larger office with more appointment slots.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "CDC",
      name: "Cedar City Regional Airport",
      distance: "3 miles northwest of downtown Cedar City",
      address: "2470 W 1725 N, Cedar City, UT 84720",
      note: "Regional airport with daily flights to Salt Lake City via Delta Connection. About 10 minutes from SUU campus.",
      flightUrl: "https://www.cedarcity.org/244/Airport",
      flightLabel: "CDC Airport",
      featured: true,
    },
    {
      code: "SGU",
      name: "St. George Regional Airport",
      distance: "60 miles southwest of Cedar City",
      address: "4550 S Airport Pkwy, St. George, UT 84790",
      note: "Regional airport with direct flights to major hubs. About 1 hour from Cedar City via I-15.",
      flightUrl: "https://www.flysgu.com/",
      flightLabel: "SGU Airport",
      featured: false,
    },
  ],
};